// src/pages/MyTeams.js
import { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { FiUsers, FiCalendar } from 'react-icons/fi';
import { getMyTeams } from '../../services/action';

const MyTeams = () => {
  const [teams, setTeams] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchTeams = async () => {
      try {
        const data = await getMyTeams();
        setTeams(data);
        setError('');
      } catch (err) {
        setError(err.response?.data?.message || 'Failed to load teams');
      } finally {
        setLoading(false);
      }
    };

    fetchTeams();
  }, []);

  if (loading) {
    return (
      <div className="d-flex justify-content-center py-5">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="container py-4">
        <div className="alert alert-danger">{error}</div>
        <Link to="/" className="btn btn-primary">
          Go Home
        </Link>
      </div>
    );
  }

  return (
    <div className="container py-4">
      <h2 className="mb-4">My Teams</h2>
      
      {teams.length === 0 ? (
        <div className="card shadow">
          <div className="card-body text-center py-5">
            <FiUsers className="h1 text-muted mb-3" />
            <h4>You're not part of any teams yet</h4>
            <p className="text-muted">
              Contact your supervisor to be added to a team
            </p>
          </div>
        </div>
      ) : (
        <div className="row g-4">
          {teams.map(team => (
            <div key={team._id} className="col-md-6 col-lg-4">
              <div className="card h-100 shadow">
                <div className="card-body">
                  <h5 className="card-title">{team.name}</h5>
                  {team.description && (
                    <p className="card-text text-muted">{team.description}</p>
                  )}
                  <div className="mt-3">
                    <small className="text-muted d-block mb-2">
                      <FiCalendar className="me-2" />
                      Created: {new Date(team.createdAt).toLocaleDateString()}
                    </small>
                    <small className="text-muted d-block">
                      <FiUsers className="me-2" />
                      {team.members.length} members
                    </small>
                    <small className="text-muted d-block mt-2">
                      Created by: {team.createdBy?.name || team.createdBy?.email}
                    </small>
                  </div>
                </div>
                <div className="card-footer bg-transparent">
                  <Link 
                    to={`/team/${team._id}`}
                    className="btn btn-outline-primary btn-sm"
                  >
                    View Team
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default MyTeams;